import React from "react";
import Icon from "components/AppIcon";

const QuestionCard = ({ question, questionIndex, totalQuestions, selectedAnswer, onAnswerSelect }) => {
  if (!question) return null;

  return (
    <div
      className="rounded-xl p-4 md:p-6 lg:p-8"
      style={{ backgroundColor: "var(--color-card)", border: "1px solid var(--color-border)" }}
    >
      <div className="flex items-start gap-3 mb-6">
        <span
          className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-mono font-bold"
          style={{ backgroundColor: "var(--color-primary)", color: "var(--color-primary-foreground)" }}
        >
          {questionIndex + 1}
        </span>
        <h2
          className="text-base md:text-lg lg:text-xl font-semibold leading-relaxed pt-0.5"
          style={{ color: "var(--color-text-primary)" }}
        >
          {question?.text}
        </h2>
      </div>
      <div className="space-y-3">
        {question?.options?.map((option, idx) => {
          const isSelected = selectedAnswer === idx;
          const letters = ["A", "B", "C", "D", "E", "F"];
          return (
            <button
              key={idx}
              onClick={() => onAnswerSelect(idx)}
              className="w-full text-left rounded-lg p-3 md:p-4 transition-all duration-200 flex items-center gap-3 group"
              style={{
                backgroundColor: isSelected ? "var(--color-primary)" : "var(--color-muted)",
                border: `2px solid ${isSelected ? "var(--color-primary)" : "var(--color-border)"}`,
                color: isSelected ? "var(--color-primary-foreground)" : "var(--color-text-primary)",
              }}
              aria-pressed={isSelected}
            >
              <span
                className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-mono font-bold transition-all"
                style={{
                  backgroundColor: isSelected ? "rgba(255,255,255,0.25)" : "var(--color-card)",
                  color: isSelected ? "var(--color-primary-foreground)" : "var(--color-primary)",
                  border: `1px solid ${isSelected ? "rgba(255,255,255,0.4)" : "var(--color-border)"}`,
                }}
              >
                {letters?.[idx] || idx + 1}
              </span>
              <span className="text-sm md:text-base font-medium leading-snug">{option}</span>
              {isSelected && (
                <span className="ml-auto flex-shrink-0">
                  <Icon name="CheckCircle" size={18} color="var(--color-primary-foreground)" strokeWidth={2.5} />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;